const searchEngineList = ["google", "bing"];

export default searchEngineList;
